import { useRef } from "react";
import { useReveal } from "@/lib/animations";
import { ASSETS } from "@/lib/data";

export const PhilosophySection = () => {
  const ref = useRef(null);
  useReveal(ref);

  return (
    <section
      ref={ref}
      data-testid="philosophy-section"
      className="relative bg-[#0B132B] text-white overflow-hidden"
    >
      <img
        src={ASSETS.familyBeach}
        alt="A family walking on the beach at sunset"
        className="absolute inset-0 w-full h-full object-cover opacity-30"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0B132B] via-[#0B132B]/85 to-[#0B132B]/30" />
      <div className="absolute inset-0 grain pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 py-16 md:py-36 grid grid-cols-1 lg:grid-cols-12">
        <div className="lg:col-span-8">
          <p
            data-reveal
            className="text-sm tracking-[0.2em] uppercase text-[#29ABE2] font-semibold mb-6"
          >
            Our philosophy
          </p>
          <blockquote
            data-reveal
            className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.02]"
          >
            "We believe the right insurance plan isn't a product sold to you —
            it's a <span className="text-gradient-breeze">promise made with you</span>,
            for the people you love most."
          </blockquote>
          <div data-reveal className="mt-10 flex items-center gap-4">
            <img
              src="/brandon-beal.jpg"
              alt="Brandon Beal"
              className="w-14 h-14 rounded-full object-cover ring-2 ring-[#29ABE2]/40"
            />
            <div>
              <div className="font-heading font-bold text-lg">Brandon Beal</div>
              <p className="text-sm tracking-[0.2em] uppercase text-[#29ABE2] font-semibold mt-1">
                Founder &amp; CEO
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
